import React from 'react';
import { CLIENT_LOGOS } from '../mock';

const LogoBadge = ({ name }) => (
  <div className="mx-6 flex-shrink-0 group">
    <div className="h-16 min-w-[160px] px-6 flex items-center justify-center rounded-xl border border-neutral-200 bg-white/70 hover:border-[#22c55e] hover:bg-white hover:shadow-md transition-all duration-300">
      <span className="font-bold text-neutral-500 group-hover:text-black transition-colors text-[15px] whitespace-nowrap tracking-tight">
        {name}
      </span>
    </div>
  </div>
);

export default function LogoCarousel() {
  const doubled = [...CLIENT_LOGOS, ...CLIENT_LOGOS];
  return (
    <section className="py-16 bg-white overflow-hidden border-t border-neutral-100">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 mb-10 text-center">
        <h2 className="text-2xl md:text-3xl font-black text-black">
          <span className="text-[#22c55e]">80+</span> Who Automate Their Businesses With Xxpand
        </h2>
      </div>

      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />
        <div className="marquee-track">
          {doubled.map((name, i) => (
            <LogoBadge key={`${name}-${i}`} name={name} />
          ))}
        </div>
      </div>
    </section>
  );
}
